/**
 * Email Input Widget for RUL Forms
 */

import { Input } from 'antd';
import type { EmailInputWidget } from '@/api/types/rul.types';

interface EmailInputWidgetProps {
  widget: EmailInputWidget;
  onChange: (name: string, value: any) => void;
  error?: string;
}

export const EmailInputWidgetComponent: React.FC<EmailInputWidgetProps> = ({
  widget,
  onChange,
  error,
}) => {
  if (!widget.visible) return null;

  return (
    <div className="rul-field">
      {widget.label && (
        <label className="rul-field-label">
          {widget.label}
          {widget.required && <span className="rul-field-required">*</span>}
        </label>
      )}
      <Input
        type="email"
        name={widget.name}
        value={widget.value || ''}
        placeholder={widget.placeholder}
        disabled={!widget.enabled}
        status={error ? 'error' : undefined}
        onChange={(e) => onChange(widget.name, e.target.value)}
      />
      {widget.help_text && !error && (
        <div className="rul-field-help">{widget.help_text}</div>
      )}
      {error && <div className="rul-field-error">{error}</div>}
    </div>
  );
};
